<template>
    <div class="phone-verification-page-result">
        <div class="phone-verification-page-result__content">
            <logos-container-ui center />
            <phone-verification-skeleton v-if="loading" />
            <div v-else>
                <div v-if="same && status === 'success'">
                    <i class="phone-verification-status__icon fas fa-check-circle" />
                    <p class="phone-verification-status__title">{{ $t('Phone number verified') }}</p>
                    <p class="phone-verification-status__description">{{ $t('You can now use your account') }}</p>
                    <p class="phone-verification-status__description">
                        <span class="fa fa-spinner fa-spin" />
                        {{ $t('You will be redirected to the login page in a few seconds') }}
                    </p>
                </div>
                <div v-if="status === 'success' && !same && !showPhoneVerification">
                    <i class="phone-verification-status__icon fas fa-check-circle" />
                    <p class="phone-verification-status__title">{{ $t('Phone number verified') }}</p>
                    <p class="phone-verification-status__description">
                         {{ $t(`We’ve verified your account with the number`) }} <strong> {{ getPhone(phone_verified, country) }} </strong> <br>
                         {{ $t(`Currently, your registered number is`) }} <strong> {{ getPhone(user?.phone, user?.country) }} </strong> <br>
                         {{ $t(`Would you like to update your registered number to match the one you just verified?`) }}
                    </p>
                    <ui-button @click="show" class="m-2" :loading="loading" :disabled="loading" :loading-text="$t('Redirecting...')" variant="secondary">
                        {{ $t('No, try again') }}
                    </ui-button>
                    <ui-button @click="confirmation" class="m-2" :loading="update" :disabled="update" :loading-text="$t('Redirecting...')">
                        {{ $t('Yes, update my number') }}
                    </ui-button>
                </div>
                <div v-else-if="showPhoneVerification">
                    <phone-verification-status :status="status" :site="site" :phone="getPhone(user.phone, user.country)" :country="country" />
                </div>
                <p class="phone-verification-page-result__support-message mt-4">
                    {{ $t('If you are still having problems with login, start a support chat') }}.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import parsePhoneNumber from 'libphonenumber-js'
import UiButton from '@/components/ui/buttons/Button.vue';
import PhoneVerificationSkeleton from '@/components/ui/skeletons/PhoneVerificationSkeleton.vue';
import LogosContainerUi from '@/components/ui/LogosContainer.vue'
import PhoneVerificationStatus from '@/components/verifications/PhoneVerificationStatus.vue';

export default {
    name: 'phone-verification-result',
    components: {
        UiButton,
        PhoneVerificationSkeleton,
        LogosContainerUi,
        PhoneVerificationStatus
    },
    data() {
        return {
            sessionUuid: this.$route.query.sessionUuid,
            status: 'pending',
            loading: false,
            site: null,
            phone_verified: null,
            country: '',
            showPhoneVerification: false,
            user: null,
            update: false,
            same: false,
        }
    },
    mounted() {
        setTimeout(() => {
            this.loadingData();
        }, 1000);
    },
    methods: {
        async loadingData() {
            try {
                this.loading = true;
                await this.getAccountDetails();
                await this.getResult();
            } catch (error) {
                this.showError(error);
            } finally {
                this.loading = false;
            }
        },
        async getAccountDetails() {
            try {
                this.loadingAccount = true;
                const { data } = await this.axiosAccount.get('/api/accounts/me');
                this.user = data;
            } catch(error) {
                this.showError(error);
            } finally {
                this.loadingAccount = false;
            }
        },
        async getResult() {
            try {
                const { data } = await this.axiosAccount.get(`/api/accounts/phone-verification/${this.sessionUuid}`);
                const { status, verifiedNumber, site, same, redirect_url } = data;
                if (same) {
                    this.same = same;
                    this.redirecting(redirect_url);
                }
                if (verifiedNumber) {
                    const { phoneNumber, countryCode } = verifiedNumber;
                    this.phone_verified = phoneNumber;
                    this.country = countryCode.countryIsoCode3166_2;
                }
                this.status = status;
                this.site = site;
            } catch (error) {
                this.showError(error);
            }
        },
        confirmation() {
            if (this.status === 'success') {
                this.updatePhoneNumber();
            }
        },
        show() {
           try {
                this.loading = true;
                this.showPhoneVerification = true; 
           } catch (error) {
                this.showError(error);
           } finally {
                this.loading = false;
           }
        },
        getPhone(phone, country) {
            const formattedPhoneNumber = parsePhoneNumber(phone, country);
            return formattedPhoneNumber.formatInternational()
        },
        redirecting(redirect_url) {
            setTimeout(() => {
                window.location.replace(redirect_url);
            }, 5000);
        },
        async updatePhoneNumber() {
            try {
                this.update = true;
                const payload = { phone: this.phone_verified, country_code: this.country, reference: this.$route.query.sessionUuid };
                const { data } = await this.axiosAccount.put('/api/accounts/phone-verification', payload);
                const { redirect_url } = data;
                if (redirect_url) {
                    this.redirecting(redirect_url);
                }
            } catch (error) {
                this.showError(error);
            }
        }
    }
};
</script>

<style lang="scss">
.phone-verification-page-result {
    text-align: center;
    position: relative;

    &__back {
        position: absolute;
        left: 0;
        top: 0;
    }

    &__content {
        max-width: 650px;
        margin-left: auto;
        margin-right: auto;
    }

    &__logo {
        margin-bottom: 35px;
    }

    &__support-message {
        color: #c4c4c4;
        font-size: 0.875rem;
        font-weight: 400;
        margin-bottom: 0;
    }

    &__img {
        max-width: 120px;
        width: 100%;
    }
}
</style>